
import { Badge } from "@/components/ui/badge";

const RecognizedAccelerators = () => {
  const recognizedAccelerators = [
    "Y Combinator", "Techstars", "500 Global", "Plug and Play",
    "Seedcamp", "AngelPad", "Founder Collective", "TechStars",
    "Antler", "Entrepreneur First", "SOSV", "Dreamit Ventures"
  ];

  return (
    <section className="container mx-auto px-6 py-16 bg-white/50 backdrop-blur">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-gray-900 mb-4">Recognized Accelerator Programs</h2>
        <p className="text-xl text-gray-600">We support startups from these and many other programs</p>
      </div>
      
      <div className="flex flex-wrap justify-center gap-3 max-w-4xl mx-auto">
        {recognizedAccelerators.map((accelerator, index) => (
          <Badge key={index} variant="secondary" className="text-sm px-3 py-1">
            {accelerator}
          </Badge>
        ))}
        <Badge variant="outline" className="text-sm px-3 py-1">
          +50 more programs
        </Badge>
      </div>
    </section>
  );
};

export default RecognizedAccelerators;
